<template>
  <div class="ut-relative">
    <div class="search-input">
      <input
        class="ga-event"
        :data-category="gacategory"
        :data-eventlabel="placeholderText"
        v-on:keyup="getMatchingResults"
        v-click-outside="hideResults"
        v-model="searchTerm"
        type="text"
        :placeholder="placeholderText"
      />
    </div>
    <search-results
      :gacategory="gacategory"
      :results="searchResults"
      :searchType="'lead'"
      @selectedResult="resultSelected"
    />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import SearchResults from '@/components/SearchResults/SearchResults.vue';
import Types from '@/Mapper/CustomType';

export default {
  name: 'LeadSearch',
  components: {
    SearchResults,
  },
  props: {
    defaultSearchTerm: {
      required: false,
      default: null,
    },
    gacategory: {
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters('userStore', [
      'isPrincipal',
    ]),
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lams: state => state.leadsListStore.leadsList,
      allLeadsListForPrincipal: state => state.principalStore.allLeadsListForPrincipal,
    }),
    searchTermIsNotEmpty() {
      return this.searchTerm && this.searchTerm.length > 0;
    },
    gaLabel() {
    },
  },
  data() {
    return {
      gaCategory: 'AgentPortal',
      searchTerm: this.defaultSearchTerm,
      searchResults: [],
      selectedResult: null,
      placeholderText: 'Search leads by name or address',
    };
  },
  methods: {
    matchingLeadsForAddress(list) {
      return list.filter(
        lam => this.getFullAddress(lam).toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1,
      ).sort((a, b) => new Date(b.agentsentleaddate) - new Date(a.agentsentleaddate));
    },
    matchingLeadsForVendorName(list) {
      return list.filter(
        lam => this.isVendorNameMatch(lam),
      ).sort((a, b) => new Date(b.agentsentleaddate) - new Date(a.agentsentleaddate));
    },
    getFullAddress(lead) {
      return `${lead.leadinfo.streetaddress ? lead.leadinfo.streetaddress : ''}  ${lead.leadinfo.suburb ? lead.leadinfo.suburb : ''}`;
    },
    isVendorNameMatch(lam) {
      if (lam && lam.leadinfo) {
        const firstName = lam.leadinfo.firstname ? lam.leadinfo.firstname.toLowerCase() : '';
        const lastName = lam.leadinfo.lastname ? lam.leadinfo.lastname.toLowerCase() : '';
        if (`${firstName} ${lastName}`.indexOf(this.searchTerm.toLowerCase()) > -1) return true;
      }
      return false;
    },
    getMatchingResults() {
      this.searchResults = [];
      if (this.searchTermIsNotEmpty) {
        if (this.isPrincipal
          && this.allLeadsListForPrincipal
          && this.allLeadsListForPrincipal.length > 0) {
          this.appendMatchingLeads(this.allLeadsListForPrincipal);
        } else {
          this.appendMatchingLeads(this.lams);
        }
      }
    },
    containsResult(result) {
      for (let i = 0; i < this.searchResults.length; i += 1) {
        if (this.searchResults[i]
          && this.searchResults[i].searchType === result.searchType) {
          switch (result.searchType) {
            case Types.Search.Lead:
              if (result.id === this.searchResults[i].id) {
                return true;
              }
            default:
              break;
          }
        }
      }
      return false;
    },
    appendResultsWithSearchType(results, searchType) {
      if (results && results.length > 0) {
        for (let i = 0; i < results.length; i += 1) {
          const result = Object.assign({}, results[i], { searchType });
          if (!(this.containsResult(result))) {
            this.searchResults.push(result);
          }
        }
      }
    },
    appendMatchingLeads(lamsList) {
      this.appendResultsWithSearchType(
        this.matchingLeadsForAddress(lamsList),
        Types.Search.Lead,
      );
      this.appendResultsWithSearchType(
        this.matchingLeadsForVendorName(lamsList),
        Types.Search.Lead,
      );
    },
    navigateToLead(selectedLead) {
      this.$apiServices.oa.agent.getById(selectedLead.agentid)
        .then((agentData) => {
          this.$router.push({
            path: `/${agentData.key}/lead/${selectedLead.leadinfo.key}${!!this.user && !!this.user.key ? `/${this.user.key}` : ''}`,
          });
        });
    },
    hideResults() {
      this.searchResults = [];
    },
    resultSelected(result) {
      if (result && result.searchType) {
        switch (result.searchType) {
          case Types.Search.Lead:
            if (!!this.agent && this.agent.id === result.agentid) {
              const gaLabel = `AID=${this.agent.id} | LeadId=${result.leadinfo.id}`;
              this.navigateToLead(result);
            } else {
              this.$emit('selected-lead', result);
              this.navigateToLead(result);
            }
            break;
          default:
            console.error(`Error in LeadSearch component\rUnhandled search type action (${result.searchType})`);
            break;
        }
      }
    },
    // gaEvent(eventAction, eventLabel) {
    //   const label = `AID=${this.agent.id}${eventLabel ? ` | ${eventLabel}` : ''}`;
    //   return {
    //     category: this.gaCategory,
    //     action: eventAction,
    //     label,
    //   };
    // },
  },
};
</script>

<style lang="scss" scoped>
.search-input {
  input {
    @apply ut-py-2 ut-px-4 ut-pr-6 ut-bg-no-repeat ut-w-full;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid #979797;
    border-radius: 3px;
    appearance: none;
    background-size: 22px;
    background-color: #F7F5F3;
    background-position: 98% center;
    background-image: url('../assets/styles/frontend-library/images/magnifier.svg');

    //IE fix to remove default select list arrow
    &::-ms-expand {
      display: none;
    }

    &:focus {
      outline-width: 0;
      @apply ut-border ut-border-green-400;
      box-shadow: 0 0 0 1px rgba(78, 182, 72, .16), inset 0 0 0 1px theme('colors.green.400');
    }
  }
}

</style>
